import { createSlice } from '@reduxjs/toolkit';

// ** Initial State
const initialState = {
  params: {
    page: 1,
    limit: 10,
    start: null,
    end: null,
  },
};

// ** Slice
export const balanceReportSlice = createSlice({
  name: 'balanceReport',
  initialState,
  reducers: {
    setParams: (state, action) => {
      state.params = {
        ...state.params,
        ...action.payload,
      };
    },
  },
});

// ** Actions
export const { setParams } = balanceReportSlice.actions;

// ** Selectors
export const balanceReportParamsSelector = (state) => state.balanceReport.params;

// ** Reducer
export const balanceReportReducer = balanceReportSlice.reducer; 